<template>
  <div class="form-content">
    <div class="public-form-content">
      <public-business-form
        ref="publicBusinessForm"
        :renderSence="shareConfig.operationAuth === 'READ' ? 'read' : 'edit'"
        :formType="shareConfig.operationAuth === 'READ' ? 'DETAIL_FORM' : 'EDIT_FORM'"
        :globalData="shareConfig"
        @changeGlobalData="handleChangeGlobalData"
      ></public-business-form>
    </div>
    <div v-if="shareConfig.operationAuth !== 'READ' && (shareButton && shareButton.buttonName !== undefined)" class="public-form-btn">
      <cube-button v-if="shareButton" primary @click="handleClick">
        {{ shareButton.buttonName }}
      </cube-button>
    </div>
  </div>
</template>

<script>
import PublicBusinessForm from '../public-business-form/public-business-form'
import { mapState, mapMutations } from 'vuex'
import { INIT_PUBLIC_FORM, SET_SHARE_PAYLOAD, SET_GLOBAL_DATA_READY } from '@/store/public-form.store.js'
import apis from '@/api'

export default {
  name: 'PublicFormContent',
  components: {
    PublicBusinessForm
  },
  computed: {
    ...mapState({
      token: state => state.authModule.token,
      shareConfig: state => state.publicFormModule.shareConfig,
      shareButton: state => state.publicFormModule.shareButton,
      publicConfig: state => state.publicFormModule.publicConfig
    })
  },
  created() {
    if (this.$route.query.shareId && !this.$route.query.type) {
      this.queryShareConfig(this.$route.query.shareId)
    } else {
      this.queryShareConfigEdit(this.$route.query.shareId)
    }
  },
  beforeDestroy() {
    this.setSharePayload(null)
  },
  methods: {
    ...mapMutations('publicFormModule', {
      initPublicFormStore: INIT_PUBLIC_FORM,
      setSharePayload: SET_SHARE_PAYLOAD,
      setGlobalDataReady: SET_GLOBAL_DATA_READY
    }),
    handleChangeGlobalData(flag) {
      this.setGlobalDataReady(flag)
    },
    handleClick() {
      this.$refs.publicBusinessForm && this.$refs.publicBusinessForm.validate((formData, rowId, tableData) => {
        if (this.shareButton.buttonCode === 'SUBMIT') {
          this.doSubmit(formData, rowId, tableData)
        } else if (this.shareButton.buttonCode === 'SAVE') {
          this.doSave(formData, rowId, tableData)
        } else if (this.shareButton.buttonCode === 'RESTART') {
          this.doRestart(formData, rowId, tableData)
        }
      })
    },
    queryShareConfig(shareId) {
      this.setSharePayload({
        headers: {
          xdaptenantid: this.$route.query.tenantId
        }
      })
      const request = {
        ...apis.PUBLIC_FORM.QUERY_SHARE_CONFIG,
        params: {
          shareId
        }
      }
      return new Promise((resolve, reject) => {
        this.$request(request).asyncThen((resp) => {
          if (resp.code === 'ok') {
            // 所有显示字段从displayComponents里拿
            resp.data.shareConfig.displayAll = false
            this.initPublicFormStore(resp.data)
            this.init()
            this.$router.replace({ name: this.$route.name,
              query: {
                ...this.$route.query,
                formId: resp.data.shareConfig.formId,
                documentId: resp.data.shareConfig.documentId,
                processId: resp.data.shareConfig.processId
              } })
            resolve(resp.data)
          }
        }, (err) => {
          reject(err)
        }).asyncErrorCatch(err => {
          reject(err)
        })
      })
    },
    queryShareConfigEdit(shareId) {
      this.setSharePayload({
        headers: {
          xdaptenantid: this.$route.query.tenantId
        }
      })
      const request = {
        ...apis.PUBLIC_FORM.QUERY_SHARE_CONFIG_EDIT,
        params: {
          shareId: shareId,
          documentId: this.$route.query.documentId
        }
      }
      return new Promise((resolve, reject) => {
        this.$request(request).asyncThen((resp) => {
          if (resp.code === 'ok') {
            // 所有显示字段从displayComponents里拿
            resp.data.shareConfig.displayAll = false
            resp.data.shareConfig.documentId = this.$route.query.documentId
            this.initPublicFormStore(resp.data)
            this.init()
            this.$router.replace({ name: this.$route.name,
              query: {
                ...this.$route.query,
                formId: resp.data.shareConfig.formId,
                documentId: resp.data.shareConfig.documentId,
                processId: resp.data.shareConfig.processId
              } })
            resolve(resp.data)
          }
        }, (err) => {
          reject(err)
        }).asyncErrorCatch(err => {
          reject(err)
        })
      })
    },
    init() {
      if (!this.publicConfig.isExpire) {
        if (this.shareConfig.shareScope === 'ANY') {
          this.setSharePayload({
            headers: {
              xdaptoken: this.publicConfig.shareToken,
              xdaptenantid: this.$route.query.tenantId,
              xdapshare: this.$route.query.shareId
            },
            urlPrefix: '/shareApi/' + this.publicConfig.urlPrefix
          })
          this.$nextTick(() => {
            this.$refs.publicBusinessForm && this.$refs.publicBusinessForm.init()
          })
        } else if (this.shareConfig.shareScope === 'INNER') {
          this.setSharePayload({
            urlPrefix: '',
            headers: {
              xdaptoken: this.token,
              xdaptenantid: this.$route.query.tenantId,
              xdapshare: this.$route.query.shareId
            }
          })
          if (this.token) {
            this.checkTenantUser().then((data) => {
              if (data.isTenantUser) {
                this.$nextTick(() => {
                  this.$refs.publicBusinessForm && this.$refs.publicBusinessForm.init()
                })
              } else {
                this.$router.replace({ name: '423', query: { publicFormStatus: true } })
              }
            })
          } else {
            this.$router.push({ name: 'account' })
          }
        }
      } else {
        this.$router.replace({ name: '423', query: { publicFormStatus: true } })
      }
    },
    checkTenantUser() {
      const request = {
        ...apis.PUBLIC_FORM.CHECK_TENANT_USER,
        params: {
          tenantId: this.$route.query.tenantId
        }
      }
      return new Promise((resolve, reject) => {
        this.$request(request).asyncThen(resp => {
          resolve(resp.data)
        }, err => {
          reject(err)
        }).asyncErrorCatch(err => {
          reject(err)
        })
      })
    },
    doSubmit(formData, rowId, tableData) {
      const request = {
        ...apis.APP_PAGE.DETAIL_PAGE_PROCESS_SUBMIT,
        params: {
          formId: this.shareConfig.formId,
          documentId: this.shareConfig.documentId,
          rowId: rowId,
          data: formData,
          tableData: tableData
        }
      }
      this.$loading.show()
      this.$request(request).asyncThen(resp => {
        if (resp.code === 'ok') {
          this.$loading.hide()
          this.$router.push({
            name: 'publicSubmitSuccess',
            query: {
              tenantId: this.$route.query.tenantId,
              editUrl: resp.data.editUrlAfterShareAndSubmit
            }
          })
        }
      })
    },
    doSave(formData, rowId, tableData) {
      const request = {
        ...apis.APP_PAGE.DETAIL_PAGE_SUBMIT_BUSINESS_DATA,
        params: {
          formId: this.shareConfig.formId,
          documentId: this.shareConfig.documentId,
          rowId: rowId,
          data: formData,
          tableData: tableData
        }
      }
      this.$loading.show()
      this.$request(request).asyncThen(resp => {
        if (resp.code === 'ok') {
          this.$loading.hide()
          if (this.$route.query.type) {
            this.$router.push({
              name: 'publicSubmitSuccess',
              query: {
                tenantId: this.$route.query.tenantId,
                type: this.$route.query.type
              }
            })
          } else {
            this.$router.push({
              name: 'publicSubmitSuccess',
              query: {
                tenantId: this.$route.query.tenantId
              }
            })
          }
          // this.$router.push({
          //   name: 'publicSubmitSuccess',
          //   query: {
          //     tenantId: this.$route.query.tenantId
          //   }
          // })
        }
      })
    },
    doRestart(formData, rowId, tableData) {
      const request = {
        ...apis.APP_PAGE.DO_APPROVE,
        params: {
          processId: this.shareConfig.processId,
          taskId: this.shareConfig.taskId,
          formId: this.shareConfig.formId,
          documentId: this.shareConfig.documentId,
          rowId: rowId,
          data: formData,
          tableData: tableData
        }
      }
      this.$loading.show()
      this.$request(request).asyncThen(resp => {
        if (resp.code === 'ok') {
          this.$loading.hide()
          this.$router.push({
            name: 'publicSubmitSuccess',
            query: {
              tenantId: this.$route.query.tenantId
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.form-content {
  .public-form-btn {
    display: flex;
    align-items: center;
    height: 4.29rem;
    padding: 0 1rem;
    .cube-btn {
      height: 2.86rem;
    }
  }
}
</style>
